var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefHat24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400-400q17 0 28.5-11.5T440-440v-120q0-17-11.5-28.5T400-600q-17 0-28.5 11.5T360-560v120q0 17 11.5 28.5T400-400Zm-200 80v-140q-46-23-73-66.5T100-621q0-75 51.5-127T278-800q12 0 24.5 2t24.5 5q25-41 65-64t88-23q48 0 88 23t65 64q12-3 24-5t25-2q75 0 126.5 52T860-621q0 51-27 94.5T760-460v140H200Zm360-80q17 0 28.5-11.5T600-440v-120q0-17-11.5-28.5T560-600q-17 0-28.5 11.5T520-560v120q0 17 11.5 28.5T560-400ZM280-80q-33 0-56.5-23.5T200-160v-80h560v80q0 33-23.5 56.5T680-80H280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHat24Dp);
export default __webpack_public_path__ + "static/media/chef_hat_24dp.2ae68c293628431d6564ded78ea459fa.svg";
export { ForwardRef as ReactComponent };